export default __webpack_public_path__ + "static/media/H365.ea257349.png";